<template>
  <PageWrapper :maxWidth="5000" :handleBack="goToDashboard">
    <Tabs v-if="shouldShowPage" class="margin-top-16" :tabs="tabs">
      <template #tab-0> <TabOneContent /> </template>
      <template #tab-1> <TabTwoContent /> </template>
    </Tabs>
  </PageWrapper>
</template>

<script>
import { PageWrapper, Tabs } from "@/components/re-design";
import TabOneContent from "./components/TabOneContent.vue";
import TabTwoContent from "./components/TabTwoContent.vue";
import { goToRoute } from "@/shared/utils";

export default {
  components: {
    PageWrapper,
    Tabs,
    TabOneContent,
    TabTwoContent,
  },
  data() {
    return {
      tabs: ["راهنما", "پیوست ها"],
      shouldShowPage: true,
    };
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(val) {
        this.shouldShowPage = false;
        setTimeout(() => (this.shouldShowPage = true), 100);
      },
    },
  },
  methods: {
    goToDashboard() {
      goToRoute("dashboard", {}, {}, false);
    },
  },
};
</script>
